import React, { useState, useEffect } from "react";
import {
  getBookings,
  updateBookingStatus,
  deleteBooking,
} from "./firestoreServices";

const BookingDashboard = () => {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const data = await getBookings();
    setBookings(data);
  };

  const handleStatus = async (id, val) => {
    await updateBookingStatus(id, val);
    loadData(); // تحديث عشان نشوف التغيير
  };

  const handleDelete = async (id) => {
    await deleteBooking(id);
    loadData();
  };

  return (
    <div className="dashboard-container">
      <h2 className="page-title">إدارة الحجوزات</h2>

      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>الاسم</th>
              <th>الهاتف</th>
              <th>الخدمة</th>
              <th>التاريخ المفضل</th>
              <th>الحالة</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  لا توجد حجوزات
                </td>
              </tr>
            ) : (
              bookings.map((b) => (
                <tr key={b.id}>
                  <td>{b.name}</td>
                  <td>{b.phone}</td>
                  <td>{b.service}</td>
                  <td>
                    {b.date} <small>({b.time})</small>
                  </td>
                  <td>
                    <select
                      value={b.status}
                      onChange={(e) => handleStatus(b.id, e.target.value)}
                      className="admin-select"
                      style={{ width: "auto", padding: "5px" }}
                    >
                      <option value="جديد">جديد</option>
                      <option value="تم التواصل">تم التواصل</option>
                      <option value="ملغي">ملغي</option>
                    </select>
                  </td>
                  <td>
                    <button
                      onClick={() => handleDelete(b.id)}
                      className="btn btn-danger btn-action"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingDashboard;
